export enum ModuleTokens {
  Name = 'clientUserBase'
}

export enum ClientUserRoles {
  Manager = 'MANAGER',
  TechnicalUser = 'TECHNICAL_USER',
  FinancialUser = 'FINANCIAL_USER'
}
